import { useCharsPerLineField } from '@/features/settings/components/PrinterConfiguration/form'
import { getCharsPerLineOptions } from '@/features/settings/components/PrinterConfiguration/form/utils/getCharsPerLineOptions'
import LabeledSelect from '@/features/settings/components/forms/LabeledSelect'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const CharsPerLineField: FC = () => {
    const { t } = useTranslation()

    const [value, onChange] = useCharsPerLineField()

    return (
        <LabeledSelect
            value={value}
            onValueChange={onChange}
            label={t('settings.printers.printerConfiguration.field.charsPerLine.label')}
            options={getCharsPerLineOptions()}
        />
    )
}

export default CharsPerLineField
